import {useState} from "react";
import {uploadService} from "../services/uploadService";
import type {UploadRequestOption} from 'rc-upload/lib/interface';
import {UploadFileItem} from "../types/upload";
import {openSuccessNotification, showErrorNotification} from "../helpers/mainHelpers";
import {resizeImage} from "../helpers/imageHelper";
import * as BUCKETS from "../enums/buckets"


export const useUploadController = () => {
  const [isFilesLoading, setIsFilesLoading] = useState(false)
  const [currentFiles, setCurrentFiles] = useState<UploadFileItem[]>([])


  const uploadFile = async (uploadProps: UploadRequestOption<any> & {
    bucketId: string;
  }) => {
    setIsFilesLoading(true)
    const {file, onSuccess, onError, bucketId} = uploadProps
    try {
      let correctFile = file as unknown as File
      const isImage = correctFile.type.startsWith("image/")
      if (isImage) {
        const blob = await resizeImage(correctFile, 800, 600);
        correctFile = new File([blob], correctFile.name, {type: correctFile.type});
      }
      const response = await uploadService.uploadFile({file: correctFile, bucketId})
      if (onSuccess) {
        onSuccess(response)
      }
      return response
    } catch (error) {

      if (onError) {
        const uploadError = new Error("Upload file error!")
        onError(uploadError)
      }
      console.error(error)
      showErrorNotification({message: "Помилка під час завантаження файлу!", description: JSON.stringify(error)});
    } finally {
      setIsFilesLoading(false)
    }
  }

  const uploadSunEditorContentImage = async (props: {file: File} ) => {
    setIsFilesLoading(true)
    try {
      const {file} = props
      const blob = await resizeImage(file, 800, 600);
      const optimizedFile = new File([blob], file.name, {type: file.type});
      const response = await uploadService.uploadFile({file: optimizedFile, bucketId: BUCKETS.MAIN})
      return response
    }catch (error){
      showErrorNotification({message: "Помилка під час завантаження зображення!", description: JSON.stringify(error)});
      return  undefined
    }finally {
      setIsFilesLoading(false)
    }
  }

  const deleteFile = async (props: { fileId: string, buketId: string }) => {
    setIsFilesLoading(true)
    const {fileId, buketId} = props
    try {
      const response = await uploadService.deleteFile({fileId, buketId})
      openSuccessNotification("Файл успішно видалено!")
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка під час видалення файлу!", description: JSON.stringify(error)});
    } finally {
      setIsFilesLoading(false)
    }
  }

  const fetchFilesHandler = async (props: { fileIds: string[], bucketId: string }) => {
    const {fileIds, bucketId} = props
    setIsFilesLoading(true)
    setCurrentFiles([])
    try {
      const files = await uploadService.getFiles({fileIds, bucketId})
      if (files?.length) {
        setCurrentFiles(files)
      }

    } catch (error) {

    } finally {
      setIsFilesLoading(false)
    }
  }

  const downloadFileHandler = async (id: string) => {
    try {
      await uploadService.downloadFile(id)
    } catch (error) {
      console.error(error)
    }
  }
  return {uploadFile, isFilesLoading, deleteFile, fetchFilesHandler, currentFiles, downloadFileHandler, uploadSunEditorContentImage}
}